export default __webpack_public_path__ + "static/media/Nathan_with_Donated_Presents.bc22cb50.jpg";